import { Component, OnInit } from '@angular/core';
import { CruiseService } from '../services/cruise.service';
import { PlatformLocation } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {
  public availableOffers: any = [];
  public merchantsetup: any = {};
  private baseURL: any = ''; private fullURL: any = '';

  constructor(private flightService: CruiseService, platformLocation: PlatformLocation) {
    this.baseURL = (platformLocation as any).location.origin;
    this.merchantsetup = this.flightService.getSetupData();
    this.fullURL = (platformLocation as any).location.pathname;
  }

  ngOnInit() {

    this.merchantsetup = this.flightService.getSetupData();

    if (!localStorage.getItem(this.baseURL + "offers")) {
      this.getAvailableOffers();
    }
    else {
      this.availableOffers = JSON.parse(localStorage.getItem(this.baseURL + "offers"));
      this.availableOffers = this.flightService.getpageOffers(this.fullURL);
      setTimeout(() => {
        $('.owl-carousel.banner').owlCarousel({
          margin: 30,
          autoplay: true,
          loop: false,
          rewind: true,
          autoplayTimeout: 2500,
          lazyLoad: true,
          nav: true,
          navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
          responsive: {
            0: { items: 1, },
            576: { items: 3, },
            768: { items: 4, },
            992: { items: 5, }
          }
        });
      }, 100);
    }
  }


  getAvailableOffers() {
    this.flightService.getAvailableOffers("Offer").subscribe(
      data => {
        var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == "success") {
          this.availableOffers = resp.offers;
          localStorage.setItem(this.baseURL + "offers", JSON.stringify(resp.offers));
          this.availableOffers = this.flightService.getpageOffers(this.fullURL);
          //console.log(JSON.stringify(resp.offers));

          setTimeout(() => {
            $('.owl-carousel.banner').owlCarousel({
              margin: 30,
              autoplay: true,
              loop: false,
              rewind: true,
              autoplayTimeout: 2500,
              lazyLoad: true,
              nav: true,
              navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
              responsive: {
                0: { items: 1, },
                576: { items: 3, },
                768: { items: 4, },
                992: { items: 5, }
              }
            });
          }, 100);
          // this.loadimages();
        }
      }
    )
  }
}
